import { Link } from 'react-router-dom';

/**
 * SafeLink Component
 * 
 * Wraps React Router's Link component to mark internal navigations with state.
 * This allows ProtectedRoute to distinguish between internal navigation (allowed)
 * and direct URL access (redirected to Landing).
 * 
 * Usage: Replace <Link to="/path">Text</Link> with <SafeLink to="/path">Text</SafeLink>
 */
const SafeLink = ({ to, children, className, ...props }) => {
  return (
    <Link 
      to={to} 
      state={{ from: 'internal' }}
      className={className}
      {...props}
    >
      {children}
    </Link>
  );
};

export default SafeLink;
